export default __webpack_public_path__ + "static/media/usercircle.91db3ce4.svg";